export default __webpack_public_path__ + "static/media/prizesDummy.619b2a61.png";